import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const Announcements = React.lazy(() => import('./index'));
const AnnounceTable = React.lazy(() => import('./announceTable'));
const Announcement = React.lazy(() => import('./announce'));
const AnnounceDetail = React.lazy(() => import('./announceDetail'));

export const useAnnouncementRoutes = () => {

    return (
        <Route path="announcements" element={<Suspense fallback={<div>منتظر باشید...</div>}><Announcements /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><AnnounceTable/></Suspense> } />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><Announcement/></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><AnnounceDetail/></Suspense> } />
            </Route>
        </Route>
    )
}